import React, { useMemo } from "react";
import { keyBy } from "@common/helpers/collections";
import { mapValues } from "@common/helpers/objects";
import { Transaction } from "@common/types/transaction";
import { TaxQuestion } from "@common/taxSavingRules";
import { TaxQuestions } from "../TaxQuestions/TaxQuestions";
import { TaxQuestionAnswerSelect } from "../TaxQuestions/TaxQuestionAnswerSelect";
import { AnswerHandler, TaxAnswers } from "../TaxQuestions/types";

interface Props {
    transaction: Transaction;
    onAnswer: AnswerHandler;
    questions: TaxQuestion[];
}

export const TransactionTaxQuestions: React.FC<Props> = ({
    transaction,
    onAnswer,
    questions,
}) => {
    const answersByKey = useMemo(
        () =>
            mapValues(
                keyBy(transaction.taxQuestionAnswers, "key"),
                "answer",
            ) as TaxAnswers,
        [transaction.taxQuestionAnswers],
    );

    if (questions.length === 0) {
        return null;
    }

    return (
        <div
            className="transaction-details__questions mb-3"
            data-testid="transaction-details-questions-container"
        >
            <TaxQuestions
                questions={questions}
                answers={answersByKey}
                onAnswer={onAnswer}
                transaction={transaction}
                renderAnswerComponent={(options) => (
                    <TaxQuestionAnswerSelect {...options} />
                )}
            />
        </div>
    );
};
